import { inject } from '@angular/core';
import { IHttpOptions } from '@partners/http';
import { isEmptyObject } from '@partners/utils';
import { CatalogService } from '../services/catalog.service';

export const residenceCatalogGuard = async (options: IHttpOptions = {}): Promise<boolean> => {
  const catalogService = inject(CatalogService);
  const residenceCatalog = await catalogService.loadResidence(options);
  return !isEmptyObject(residenceCatalog);
};
